import { NgModule } from '@angular/core';
import { LuStickyFiltersResolverService } from './sticky-filters-resolver.service';
import { LuStickyFiltersService } from './sticky-filters.service';

@NgModule({
	providers: [LuStickyFiltersService, LuStickyFiltersResolverService]
})
export class LuStickyFiltersModule {}
